<div class="grid-wrapper stack stack-space-m">
  <ng-container *ngFor="let subCategory of category.subCategories; trackBy: trackById">
    <ng-container
      *ngFor="let eduContentSearch of subCategory.contents; trackBy: trackByEduContentId; let isLast = last"
    >
      <campus-edu-content-result-loader [eduContentId]="eduContentSearch.eduContent.id">
        <div *ngIf="eduContentSearch?.eduContent?.isText && category.config?.theme !== 'wist-je-dat'">
          <campus-froala-viewer [content]="eduContentSearch.eduContent.data | mathjax"></campus-froala-viewer>
        </div>

        <div class="flex flex inline gap-s" *ngIf="eduContentSearch?.eduContent?.isLink">
          <p>Link:</p>
          <a
            [href]="eduContentSearch.eduContent.publishedEduContentMetadata.link | safeUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ eduContentSearch.eduContent.title || 'Ga naar link' }}
          </a>
        </div>

        <div class="flex flex inline gap-s" *ngIf="eduContentSearch?.eduContent?.isWebApp">
          <p>Open web-app:</p>
          <a (click)="openWebApp(eduContentSearch.eduContent)" rel="noopener noreferrer" href="">
            {{ eduContentSearch.eduContent.title || 'Ga naar app' }}
          </a>
        </div>

        <ng-container
          [ngSwitch]="eduContentSearch?.eduContent?.isYouTubeEmbed"
          *ngIf="eduContentSearch?.eduContent?.isVideo"
        >
          <div class="stack gap-l">
            <iframe
              *ngSwitchCase="true"
              [src]="eduContentSearch.eduContent.publishedEduContentMetadata.link | safeUrl"
              [title]="eduContentSearch.eduContent.publishedEduContentMetadata.title"
              frameborder="0"
              class="[ w-xl h-s ]"
              allow="autoplay; encrypted-media; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            >
            </iframe>
            <campus-media-player
              *ngSwitchCase="false"
              [poster]="
                eduContentSearch.eduContent.image
                  ? (eduContentSearch.eduContent.image | assetsPath: 'images':'educontent')
                  : null
              "
              [src]="eduContentSearch.eduContent | streamUrl"
              [useHls]="true"
              class="[ w-xl h-s corner-inherit ]"
            ></campus-media-player>

            <div *ngSwitchDefault>Onbekend video type</div>
          </div>
        </ng-container>

        <div class="isolated-container" *ngIf="category.config?.theme === 'wist-je-dat'">
          <dcr-section
            leading-icon="image-dict:lightbulb"
            [headline]="category.config?.label"
            static="true"
            outline="true"
          >
            <ng-container *ngIf="eduContentSearch.eduContent.data; else noData">
              <div class="wist-je-dat-content">
                <campus-froala-viewer [content]="eduContentSearch.eduContent.data | mathjax"></campus-froala-viewer>
              </div>
            </ng-container>
            <ng-template #noData>
              <p class="wist-je-dat-content">
                {{ eduContentSearch.eduContent.publishedEduContentMetadata.description }}
              </p>
            </ng-template>
          </dcr-section>
        </div>
      </campus-edu-content-result-loader>
    </ng-container>
  </ng-container>
</div>
